


 

import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Он ударил белку поперёк спины. 
        Она упала, извиваясь в предсмертных судорогах. 
        Он внимательно смотрел на неё.
      </p>
      
      <p class="mb-3">
        Затем пошёл дальше. 
        Он шёл среди кипарисов и камней, под палящим солнцем.
      </p>
      
      <p class="mb-3">
        Он приехал сюда, чтобы «отсидеться» перед новой книгой. 
        Где-то нужно было спрятать себя, пока не нарастёт новый панцирь, пока убежище работы не примет его в свои надёжные стены.
      </p>
      
      <p class="mb-3">
        Невыносимо было видеть людей. 
        Любой из них мог претендовать на его внимание, на часть его души. 
        А у него не было души, и нечего было дать им. 
        Единственное, что он мог предоставить – свои книги: маску, панцирь, защиту. 
        В книгах – его  настоящая жизнь, там – он великодушен, благороден, любвеобилен и смел. 
        Там он такой, каким хочет быть.
      </p>
      
      <p class="mb-3">
        В жизни он не хочет и не может быть никем. 
        Он несовместим с реальностью: всё в ней ранит или тупо бьёт его. 
        Он ничего не умеет: ни строить отношения с людьми, ни удерживать эти отношения, он умеет только прекращать их; 
        но за эту боль люди платят ему ещё большей болью.
      </p>
      
      <p class="mb-3">
        Он защищается. 
        Он наращивает панцирь, и в один прекрасный день этот панцирь прирастает навсегда. 
        Он уже не может больше ничего чувствовать, даже если бы захотел. 
        Жизнь кончилась; осталось только то, что он когда-то знал. 
        Ничего нового больше не будет; только удручающее повторение того, что было.
      </p>
      
      <p class="mb-3">
        Остался лишь его разум, который помогает ему создавать вымышленные ситуации и выходить с большим или меньшим успехом из реальных.
      </p>
      
      <p class="mb-3">
        Впечатлений больше нет. 
        Ничего нового больше не будет. 
        Только бесконечные вариации того, что было. 
        Его совершенный мозг будет создавать всё более неестественные и изысканные ситуации; 
        его книги будут издаваться всё меньшими тиражами и пользоваться всё большим успехом у двух-трёх критиков да пары сотен «интеллектуалов». 
        Престиж будет расти, читательский успех падать.
      </p>
      
      <p class="mb-3">
        Его имя войдёт в энциклопедии.
      </p>
      
      <p class="mb-5">
        Да, он выбрал этот путь, он хочет такой жизни. 
        Другой у него уже не может быть.
      </p>
      
      <p class="mb-5">
        Перебив хребёт белке, он внимательно всматривался в её конвульсии. 
        Смерть… Другой жизни уже не будет…
      </p>
      
      <p class="mb-3">
        Его тело нашли среди камней охотники, когда наступила осень. 
        Опознать его было невозможно: поработали солнце и дикие звери. 
        Что писатель N больше не пишет, никто практически не заметил: 
        да мало ли их появляется и исчезает со своими парой или парой сотен мелькнувших и ненужных книг. 
        Другой жизни у них уже не будет.
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `О другой жизни`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;